/** Questions an operator would type, shown on an empty chat. A click sends one. */
export const STARTER_QUESTIONS = [
  'How many appointments did each warehouse have last week?',
  'Which carriers were late most often this month?',
  'What share of appointments started on time, by warehouse?',
  'How many appointments were canceled last month?',
] as const
